import { useState } from "react";

import { useEditSettingsMutation } from "@evr/apis/orgSettings";
import { PlanKeys } from "@evr/constant";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectUserOrgSettings, selectUserSubscription } from "@evr/store/slices/auth";
import { CircleLoading } from "@evr/ui/CircleLoading";
import { Flex, RowContainer, Wrapper } from "@evr/ui/FlexBox";
import { ToggleSwitch } from "@evr/ui/ToggleSwitch";
import { Typography } from "@evr/ui/Typography";

export const DefaultWeatherToggle = () => {
  const orgSettings = useAppSelector(selectUserOrgSettings);
  const [defaultWeatherToggle] = useState(orgSettings.defaultWeatherToggle);


  const [editOrgSettings, { isLoading }] = useEditSettingsMutation();

  const onChange = (status: boolean) => {
    let updatedOrgSettings = { ...orgSettings };
    editOrgSettings({ ...updatedOrgSettings, defaultWeatherToggle: status });
  };

  return (
    <RowContainer width="100%" justify="flex-start">
      <Typography>Use Default weather</Typography>
      <Flex margin="0.2rem 0.2rem 0.2rem auto">
        <ToggleSwitch
          onChange={onChange}
          loading={isLoading}
          value={defaultWeatherToggle}
          checked={defaultWeatherToggle}
        ></ToggleSwitch>
        <Wrapper position="relative">{isLoading && <CircleLoading size={4} />}</Wrapper>
      </Flex>
    </RowContainer>
  );
};
